import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import './Image.scss';
import Spinner from '../Spinner';
const Image = _ref => {
  let {
    src,
    alt,
    showLoader
  } = _ref;
  const [isLoaded, setIsLoaded] = useState(false);
  const onLoadComplete = useCallback(() => {
    setIsLoaded(true);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "tap-image-wrapper"
  }, !showLoader && /*#__PURE__*/React.createElement("img", {
    src: src,
    className: "tap-image",
    alt: alt,
    onLoad: onLoadComplete,
    onError: onLoadComplete
  }), (!isLoaded || showLoader) && /*#__PURE__*/React.createElement("div", {
    className: "tap-image-spinner"
  }, /*#__PURE__*/React.createElement(Spinner, {
    style: {
      color: '#fff'
    }
  })));
};
Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  showLoader: PropTypes.bool
};
Image.defaultProps = {
  src: '',
  alt: '',
  showLoader: true
};
export default /*#__PURE__*/memo(Image);